<template>
	<div class="grid grid-cols-12">
		<slot name="label">
			<label
				class="p-4 block font-medium text-gray-700 hyphens"
				:class="[
					showReference
						? 'col-span-8 md:col-span-2'
						: 'col-span-12 md:col-span-6',
				]"
			>
				{{ __(label) }}
			</label>
			<div
				v-if="showReference"
				class="md:hidden bg-gray-100 col-span-4 lg:col-span-3"
			></div>
		</slot>

		<div
			class="p-4"
			:class="showReference ? 'col-span-8 md:col-span-6' : 'col-span-12'"
		>
			<slot name="bid"></slot>
		</div>

		<!-- <div class="col-span-1 p-4">
            <slot name="agreement"></slot>
        </div> -->

		<div
			class="col-span-4 md:col-span-4 bg-gray-100 p-3 sm:p-4 hyphens"
			v-if="showReference"
		>
			<slot name="reference"></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		showReference: {
			type: Boolean,
			required: true,
		},
		label: {
			type: String,
			required: false,
		},
	},
};
</script>

<style scoped>
.hyphens,
label {
	-webkit-hyphens: auto;
	-ms-hyphens: auto;
	hyphens: auto;
}
</style>
